import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { IGraphData } from '../models';
import { IRecipient } from '@nkr/models/index';

const EpletMmGraph = (props: { graphData: IGraphData, recipient: IRecipient }) => {
    let { graphData, recipient } = props;

    let yEpletLabels = ['High', 'Medium', 'Low', '0 MM'];

    let yEpletWait = [
        null,
        `It is estimated that you will encounter a donor with <b>Medium Eplet MM</b> every ${graphData.estimatedWaitMmIntermediate} months`,
        `It is estimated that you will encounter a donor with <b>Low Eplet MM</b> every ${graphData.estimatedWaitMmLow} months`,
        `It is estimated that you will encounter a donor with <b>No DR/DQ Eplet MM</b> every ${graphData.estimatedWaitMmNone} months`
    ];

    let epletOptions: Highcharts.Options = {
        chart: { type: 'spline' },
        credits: { enabled: false },
        title: {
            text: `<div><span><b style='font-size:22px;'>Eplet Mismatch Estimated Wait Time for ${recipient.alias}</b></span><span style='font-size:14px;display:table;margin:0 auto;'>Considers potential donors from the pre-select phase</span></div>`,
            useHTML: true
        },
        xAxis: [{
            categories: graphData.xAxis_Eplet.map(x => x.toString()),
            crosshair: true,
            title: { text: 'Months' }
        }],
        plotOptions: {
            spline: {
                lineWidth: 4,
                states: {
                    hover: {
                        lineWidth: 5
                    }
                },
                marker: {
                    enabled: false
                },
            }
        },
        yAxis: [
            { // Primary yAxis
                labels: {
                    formatter: function () {
                        return yEpletLabels[this.value];
                    },
                    style: {
                        color: '#434348'
                    }
                },
                title: {
                    text: 'Eplet MM Stratification',
                    style: {
                        color: '#434348'
                    }
                },
                max: 3.1
            }
        ],
        tooltip: {
            formatter: function () {
                return yEpletWait[this.y];
            }
        },
        legend: {
            enabled: false
        },
        series: [{
            name: '',
            type: 'spline',
            data: graphData.yAxis_Eplet,
            color: 'rgb(44, 175, 254)'
        }]
    }

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={epletOptions}
        />
    )
}

export default EpletMmGraph;